/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'checkmark-light': {
    width: 13,
    height: 14,
    viewBox: '0 0 13 14',
    data: '<mask id="svgicon_checkmark-light_a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="1" y="2" width="11" height="9"><path pid="0" d="M10.944 2.825l-6.44 6.117-2.447-2.325-.807.766 3.255 3.091 7.245-6.883-.806-.766z" _fill="#fff"/></mask><g mask="url(#svgicon_checkmark-light_a)" _fill="#fff"><path pid="1" d="M10.944 2.825l-6.44 6.117-2.447-2.325-.807.766 3.255 3.091 7.245-6.883-.806-.766z"/><path pid="2" d="M13.057.5H-.627v13h13.684V.5z"/></g>'
  }
})
